import axios from 'axios'
import { getSdkCDNFromIframe } from '@/services/utils'

const http = axios.create({
  baseURL: getSdkCDNFromIframe() || window.parent.location.origin,
  headers: {
    'Content-Type': 'application/json',
    'href': window.parent.location.href
  },
  params: {}
})

export default http